// highlight term in string
import React from "react";

export type HighLightProps = {
  text: string;
  term: string;
  className?: string;
};

export const Highlight: React.FC<HighLightProps> = ({ text, term, className }) => {
  if (!term || !text) return <div className={className}>{text}</div>;

  const normalize = (value: string) =>
    value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  const normalizedText = normalize(text);
  const normalizedTerm = normalize(term);

  const termLength = normalizedTerm.length;

  // search all occurence
  const segments: { text: string; highlight: boolean }[] = [];
  let lastIndex = 0;
  let matchIndex = normalizedText.indexOf(normalizedTerm, lastIndex);

  while (matchIndex !== -1) {
    // no higlight part
    if (matchIndex > lastIndex) {
      segments.push({ text: text.slice(lastIndex, matchIndex), highlight: false });
    }
    // Highlight part
    segments.push({ text: text.slice(matchIndex, matchIndex + termLength), highlight: true });

    lastIndex = matchIndex + termLength;
    matchIndex = normalizedText.indexOf(normalizedTerm, lastIndex); // ← cherche la suivante
  }

  // last part
  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex), highlight: false });
  }

  if (segments.length === 0) return <div className={className}>{text}</div>;

  return (
    <div className={className}>
      {segments.map((segment, index) =>
        segment.highlight ? (
          <span key={index} className="text-textHighlight">
            {segment.text}
          </span>
        ) : (
          segment.text
        )
      )}
    </div>
  );
};
